import React from "react";
import * as PropTypes from "prop-types";

export class Footer extends React.Component {
    render() {
        return <div className="footer-top">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-6 footer-info">
                        <img style={{width: "100px", height: "100px"}} src={this.props.src}/>
                        <p>{this.props.footerParagraph}</p>
                    </div>

                    <div className="col-lg-4 col-md-6 footer-links">
                        <h4>Useful Links</h4>
                        <ul>
                            {this.props.links && this.props.links.map(link => <li><i className="fa fa-angle-right"/> <a
                                href={link.href}>{link.label}</a></li>)}
                        </ul>
                    </div>

                    <div className="col-lg-4 col-md-6 footer-contact">
                        <h4>Contact Us</h4>
                        <p>
                            {this.props.contactAddress}
                            <strong>Phone:</strong> {this.props.telephone}<br/>
                            <strong>Email:</strong> {this.props.email}<br/>
                        </p>

                        <div className="social-links">
                            {this.props.twitterHref &&
                            <a href={this.props.twitterHref} className="twitter"><i className="fa fa-twitter"/></a>}
                            {this.props.facebookHref &&
                            <a href={this.props.facebookHref} className="facebook"><i className="fa fa-facebook"/></a>}
                            {this.props.instagramHref &&
                            <a href={this.props.instagramHref} className="instagram"><i className="fa fa-instagram"/></a>}
                            {this.props.googlePlusHref &&
                            <a href={this.props.googlePlusHref} className="google-plus"><i className="fa fa-google-plus"/></a>}
                            {this.props.linkedInHref &&
                            <a href={this.props.linkedInHref} className="linkedin"><i className="fa fa-linkedin"/></a>}
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

Footer.propTypes = {
    src: PropTypes.string,
    footerParagraph: PropTypes.any,
    links: PropTypes.any,
    callbackfn: PropTypes.func,
    contactAddress: PropTypes.any,
    telephone: PropTypes.any,
    email: PropTypes.any,
    twitterHref: PropTypes.string,
    facebookHref: PropTypes.string,
    instagramHref: PropTypes.string,
    googlePlusHref: PropTypes.string,
    linkedInHref: PropTypes.string
};